document.addEventListener('DOMContentLoaded', function () {
  initGamesMarquee();
});

function initGamesMarquee() {
  const marqueeSection = document.querySelector('.bb-games-marquee');
  if (!marqueeSection) return;

  const tracks = marqueeSection.querySelectorAll('.bb-games-marquee__track');

  // Set animation speed from section settings
  const sectionElement = marqueeSection.closest('section');
  const animationSpeed = sectionElement?.dataset.animationSpeed || '60s';

  tracks.forEach((track) => {
    track.style.setProperty('--animation-speed', animationSpeed);

    // Force hardware acceleration
    track.style.transform = 'translate3d(0, 0, 0)';
    track.style.backfaceVisibility = 'hidden';
    track.style.perspective = '1000pFor my x';
  });
}

// Handle window resize to re-initialize animation
let resizeTimeout;
window.addEventListener('resize', function () {
  // Debounce resize event
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initGamesMarquee();
  }, 250);

  // Ensure animations continue running after resize
  const tracks = document.querySelectorAll('.bb-games-marquee__track');
  tracks.forEach((track) => {
    track.style.animationPlayState = 'running';
  });
});

// Performance optimization
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    const tracks = document.querySelectorAll('.bb-games-marquee__track');
    tracks.forEach((track) => {
      track.style.willChange = 'transform';
    });
  });
}
